import { TextInput } from './text.mjs';
import { registerCustomElement } from '../utils.mjs';

export class BufferInput extends TextInput {}

registerCustomElement('imt-input-buffer', BufferInput);
